document
    .querySelectorAll('[data-gallery]')
    .forEach((gallery) => {

        let offset = 0;

        const
            container = gallery.querySelector('[data-gallery-container]'),
            images = gallery.querySelectorAll('[data-gallery-item]'),
            stepSize = 1224,
            maxOffset = (stepSize / 2) * (images.length - 1) * -1,
            leftStick = gallery.querySelector('[data-gallery-stick-left]'),
            rightStick = gallery.querySelector('[data-gallery-stick-right]'),
            slidePrev = () => {

                if (offset < 0)
                    offset += stepSize;
                else
                    offset = maxOffset;

                container.style.setProperty('transform', `translateX(${offset}px)`);
            },
            slideNext = () => {

                if (offset > maxOffset)
                    offset -= stepSize;
                else
                    offset = 0;

                container.style.setProperty('transform', `translateX(${offset}px)`);
            };

        leftStick.addEventListener('click', slidePrev);
        rightStick.addEventListener('click', slideNext);
    });